import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  styled,
  Typography,
} from "@mui/material";
import { Link, Outlet, useLocation } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import DomainIcon from "@mui/icons-material/Domain";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import { Logout } from "@mui/icons-material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import TimelineIcon from "@mui/icons-material/Timeline";
import { useAuth } from "../../context/authContext";
import { useState } from "react";
import HelpModal from "../Help/HelpModal";

const MenuButton = styled(ListItemButton)(({ theme }) => ({
  padding: "10px",
  justifyContent: "center",
  width: "100%",
  boxSizing: "border-box",
  "&.Mui-selected": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export const Menu = () => {
  const location = useLocation().pathname;
  const { user, logout } = useAuth();
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const [hasOpenedHelp, setHasOpenedHelp] = useState(() => {
    return localStorage.getItem("hasOpenedHelp") === "true";
  });

  const handleOpenHelp = () => {
    setHelpModalOpen(true);
    if (!hasOpenedHelp) {
      localStorage.setItem("hasOpenedHelp", "true");
      setHasOpenedHelp(true);
    }
  };

  const menuItems = [
    {
      title: "Prévisions d'occupation",
      icon: <CalendarMonthIcon color="secondary" />,
      path: "/previsions",
      roles: ["User", "Manager", "Admin"],
    },
    {
      title: "Occupation réelle",
      icon: <PeopleIcon color="secondary" />,
      path: "/occupation",
      roles: ["User", "Manager", "Admin"],
    },
    {
      title: "Achalandage destination",
      icon: <TimelineIcon color="secondary" />,
      path: "/achalandage",
      roles: ["Admin", "Manager"],
    },
    {
      title: "Grilles Info-Villégiature",
      icon: <BarChartIcon color="secondary" />,
      path: "/grilles-avt",
      roles: ["Admin"],
    },
    {
      title: "Liste des hôteliers",
      icon: <DomainIcon color="secondary" />,
      path: "/ajout-hotel",
      roles: ["Admin"],
    },
    {
      title: "Contacts",
      icon: <ContactPageIcon color="secondary" />,
      path: "/contacts",
      roles: ["Admin"],
    },
  ];

  return (
    <Box>
      {location !== "/" && user && (
        <Drawer
          anchor="left"
          variant="permanent"
          PaperProps={{
            sx: {
              backgroundColor: "primary.main",
              color: "white",
              width: "15vw",
            },
          }}
        >
          <Typography variant="h5" align="center" m={2}>
            Bienvenue,{" "}
            {user.firstName || user.lastName
              ? `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim()
              : user.email?.split("@")[0]}
          </Typography>

          <List>
            {menuItems
              .filter((item) => item.roles.includes(user.role))
              .map((item) => (
                <Link
                  key={item.title}
                  to={item.path}
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <MenuButton selected={location === item.path}>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.title} />
                  </MenuButton>
                </Link>
              ))}
          </List>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
              mt: "auto",
              mb: 2,
            }}
          >
            <IconButton
              onClick={handleOpenHelp}
              sx={{
                color: "secondary.main",
                ...(!hasOpenedHelp && {
                  "@keyframes bounceScale": {
                    "0%, 100%": { 
                      transform: "translateY(0) scale(1)" 
                    },
                    "50%": { 
                      transform: "translateY(-6px) scale(1.15)" 
                    },
                  },
                  animation: "bounceScale 2s ease-in-out infinite",
                }),
              }}
              aria-label="aide"
            >
              <HelpOutlineIcon />
            </IconButton>
            <IconButton
              onClick={logout}
              sx={{ color: "secondary.main" }}
              aria-label="déconnexion"
            >
              <Logout />
            </IconButton>
          </Box>
        </Drawer>
      )}
      <HelpModal open={helpModalOpen} onClose={() => setHelpModalOpen(false)} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          maxWidth: "100%",
          marginLeft: location === "/" ? 0 : "15vw",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};
